export function getEventDayHours(event, dateString, audience = 'exhibitor') {
  const schedule = event?.daySchedules?.find(s => s?.date === dateString);
  if (schedule) {
    if (audience === 'visitor') {
      return {
        start: schedule.visitorStart || event?.startTime || null,
        end: schedule.visitorEnd || event?.endTime || null,
      };
    }
    return {
      start: schedule.exhibitorStart || event?.startTime || null,
      end: schedule.exhibitorEnd || event?.endTime || null,
    };
  }
  return { start: event?.startTime || null, end: event?.endTime || null };
}
